import Api from '@/utils/api';
import preloader from '@/components/preloader/index.vue';

export default {
  components: {
    preloader,
  },
  data() {
    return {
      metrics: [],
      selectedMetric: null,
      order: false,
      showModal: false,
      metricId: null,
      load: false,
    };
  },
  methods: {
    /**
     * Method for getting metrics
     */
    getMetrics() {
      this.load = true;
      Api.settings.metricsConfiguration
        .get().then((response) => {
          if (!response.data.Status) {
            this.load = false;
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'error',
              show: true,
            });
            return;
          }
          this.load = false;
          this.metrics = response.data.Data;
        });
    },
    clearNewMetric() {

    },
    createMetric() {
      this.$modal.show('newMetric');
    },
    /**
     * Method for removing metric
     * @param {Number} ix - Metrics array index
     * @param {Number} id - Metric id
     */
    deleteMetric(ix, id) {
      this.load = true;
      Api.settings.metricsConfiguration
        .delete(id).then((response) => {
          this.load = false;
          if (response.data.Status) {
            this.metrics.splice(ix, 1);
            this.$root.$emit('notification', {
              message: 'Metric was deleted!',
              type: 'info',
              show: true,
            });
          } else {
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'error',
              show: true,
            });
          }
        });
    },

    /**
     * Method for sorting metrics
     */
    sortByName() {
      this.metrics.sort((a, b) => {
        if (this.order === false) {
          return a.Name.localeCompare(b.Name);
        } else {
          return b.Name.localeCompare(a.Name);
        }
      });
      this.order = !this.order;
    },

    /**
     * Method for showing remove modal dialog
     * @param {Number} ix - Metrics array index
     * @param {Number} id - Metric id
     */
    removeHolder(ix, id) {
      this.$modal.show('dialog', {
        title: 'Are you sure you want to delete this metric?',
        buttons: [{
          title: 'Yes',
          handler: () => {
            this.deleteMetric(ix, id);
            this.$modal.hide('dialog');
          },
        }, {
          title: 'No',
        }],
      });
    },

  },

  created() {
    this.getMetrics();
  },
};
